exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ps-modal-helper[data-v-886660d6]{-webkit-transition:all .35s ease;transition:all .35s ease;will-change:transform;-webkit-transform:translateY(-425%);transform:translateY(-425%)}.ps-modal-helper.is-active[data-v-886660d6]{-webkit-transition-delay:.4s;transition-delay:.4s;-webkit-transform:translateY(0);transform:translateY(0)}", ""]);

// exports
